import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { Backdrop } from '@/app/components/overlays/backdrop';
import {
  PopoverOptions,
  type PopoverOptionsProps,
} from '@/app/components/shared/dealer/components/shared/filter-options/popover-options';
import styles from '@/app/components/shared/dealer/styles.module.css';
import { cn } from '@/app/utils/cn';
import { clearForceLockScroll, forceLockScroll } from '@/app/utils/lock-scroll';

interface PopoverOptionsMobileProps
  extends Omit<PopoverOptionsProps, 'children'> {
  isShow?: boolean;
}

export const PopoverOptionsMobile = ({
  isShow = false,
  ...props
}: PopoverOptionsMobileProps) => {
  useEffect(() => {
    if (isShow) {
      forceLockScroll();
    } else {
      clearForceLockScroll();
    }
  }, [isShow]);

  if (!isShow) return null;

  return createPortal(
    <>
      <Backdrop
        className={cn('fixed z-10 xl:hidden', styles.popoverContainer)}
      />
      <PopoverOptions
        className={cn(
          'center-x absolute z-10 mt-3 w-full max-w-80',
          styles.popoverContainer
        )}
        {...props}
      />
    </>,
    document.body
  );
};
